<script setup>
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value)

const props = defineProps({
    stateKey: {
        type: String,
    },
    responseError: {
        type: Object, 
        default: () => ({ active: false, text: '' })
    },
    required: {
        type: Boolean,
        default: true
    }
})
</script>
<template>
    <label :class="['checkbox', isTouched && (isValid ? 'valid' : 'not-valid') ]">
        <div class="checkbox__inner">
            <input 
                type="checkbox" 
                class="checkbox__real-input"
                @change="storeField.updateFields(stateKey, 'title', value), validation(stateKey)" 
                v-model="value"
                :required="required"
            >
            <span class="checkbox__custom-input"></span>
            <span class="checkbox__text">
                <slot></slot> 
            </span>
        </div>
        <Transition mode="out-in">
            <span v-if="!!textError" class="input__error">{{ textError }}</span>
        </Transition>
    </label>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.checkbox {
    display: grid;
    gap: .5rem;
}
.checkbox__inner {
    display: flex;
    align-items: center;
    gap: .8rem;

}
.checkbox__real-input {
	width: 0;
	height: 0;
	opacity: 0;
	position: absolute;
	z-index: -1;
}

.checkbox__custom-input {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 0.83px solid rgba(0, 0, 0, 0.2);
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    background-color: #fff;
    transition:  var(--transition) ease-in;  
}
.checkbox__text {
	font-weight: 400;
    font-size: 1.4rem;
    line-height: 120%;
    color: rgba(29, 29, 27, 0.6);
    a {
        border-bottom: .1rem solid transparent;
        @media (hover: hover){
            &:hover {
                border-color: currentColor;
            }
        }
    }
}

.checkbox__custom-input::before {
	content: '';	
    display: inline-block;
	width: 10px;
	height: 10px;
	background-image: url('@/assets/img/icons/check_red.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px 10px;
    transform: scale(0);
    
    transition: 0.2s ease-in; 
    @media (max-width: vars.$x480) {
        // width: 2rem;
        // height: 2rem;
    } 
}
.checkbox__real-input:checked + .checkbox__custom-input {
	
}
.checkbox__real-input:checked + .checkbox__custom-input::before {
	transform: scale(1);
}
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
    transform: translateX(20px);
}
.v-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}
</style>@/stores/storeFieldData